import React from 'react';

import Tab from '../components/Tab';
import Dropdown from '../components/Dropdown';
import TypeCheckbox from './Inputs/TypeCheckbox';

const Type = () => {
  return(
    <div className='vesta-dropdown-filter-container'>
      <Tab name='Type de bien' tab='type' />

      <Dropdown title='Quel type de bien recherchez-vous ?' tab='type'>
        <TypeCheckbox />
      </Dropdown>
    </div>
  )
};

export default Type;
